import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinToString',
  standalone: false
})
export class JoinToStringPipe implements PipeTransform {
  transform(value: string[], separator: string = ', '): string {
    return value.join(separator);
  }
}
